import { getDecryptByUser } from '@/api/phoneEncrypt'
import { deliveryDetailsGetPhone } from '@/api/phoneEncrypt'

const user = async (row, key) => {
  const obj = { userId: row.userId ? row.userId : row[key] }
  return await getDecryptByUser({
    ...obj,
    type: 2
  })
}

const deliveryEmail = async row => {
  return await deliveryDetailsGetPhone({
    ...row
  })
}

export default {
  user,
  deliveryEmail
}
